import { render, staticRenderFns } from "./project-follow-button.vue?vue&type=template&id=735cf374&"
import script from "./project-follow-button.vue?vue&type=script&lang=js&"
export * from "./project-follow-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports